import script from "./WordMark.vue?vue&type=script&setup=true&lang=js"
export * from "./WordMark.vue?vue&type=script&setup=true&lang=js"

import "./WordMark.vue?vue&type=style&index=0&id=30408f5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30408f5c"]])

export default __exports__